import { Grid, Typography, Box, Snackbar, IconButton } from "@mui/material";
import Head from "next/head";
import Image from "next/image";
import theme from "#next/theme";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import GroupIcon from "@mui/icons-material/Group";
import FilterIcon from "@mui/icons-material/Filter";
import CloseIcon from "@mui/icons-material/Close";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { NewReleases } from "@mui/icons-material";

const AlertMessage = () => {
  const searchParams = useSearchParams();
  const message = searchParams.get("m");
  let messageText = null;
  if (message && message === "sde")
    messageText =
      "That search no longer exists. Searches are temporary and can't be reloaded.";
  if (message && message === "tde")
    messageText = "The requested type of search does not exist.";
  const [showMessage, setShowMessage] = useState(!!(message && messageText));

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={showMessage}
      autoHideDuration={10 * 1000}
      onClose={() => setShowMessage(false)}
      message={messageText}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={() => setShowMessage(false)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    />
  );
};

export default function HomePage() {
  return (
    <>
      <Head>
        <title>Home | Pyrra</title>
      </Head>
      <AlertMessage />
      <Box
        sx={{ width: "100%", height: "100%" }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box sx={{ width: "60%", background: theme.palette.background.paper }}>
          <Grid
            container
            direction="column"
            sx={{ pt: 2, pl: 4, pr: 4, pb: 4 }}
          >
            <Grid item display="flex" justifyContent="center">
              <Image
                src="/images/pyrraLogo.jpg"
                width={75}
                height={75}
                alt="Pyrra Technologies logo"
              />
            </Grid>
            <Grid item>
              <Typography
                variant="h2"
                sx={{ mb: 2, textAlign: "center", fontWeight: "bold" }}
              >
                Welcome to Pyrra
              </Typography>
            </Grid>
            <Grid item display="flex" alignItems="center" sx={{ mb: 1 }}>
              <AccountTreeIcon fontSize="large" sx={{ marginRight: "25px" }} />
              <Typography>
                If you have already created a project, you can run it by
                clicking its name in the sidebar to the left. To create a new
                project, start by clicking on &quot;Create Project&quot; and
                then use our project builder to craft the appropriate boolean
                search. You can preview your search results, and if you save the
                project it will appear in the sidebar to the left.
              </Typography>
            </Grid>
            <Grid item display="flex" alignItems="center" sx={{ mb: 1 }}>
              <GroupIcon fontSize="large" sx={{ marginRight: "25px" }} />
              <Typography>
                If you have a username of interest, you can quickly check if
                Pyrra has collected any information on that user - including
                biographic data and post/comment history - by using the Quick
                User Search. Alternatively, you can create a project focused on
                a user or set of users in the project builder.
              </Typography>
            </Grid>
            <Grid item display="flex" alignItems="center" sx={{ mb: 1 }}>
              <FilterIcon fontSize="large" sx={{ marginRight: "25px" }} />
              <Typography>
                You can use the Text and/or Media Search to surface
                post/comments/media from across alternative social media that
                either match a simple boolean phrase or include media that falls
                into one of the 20+ media categories. Note that these results
                are limited to the last 30 days.
              </Typography>
            </Grid>
            <Grid item display="flex" alignItems="center" sx={{ mb: 1 }}>
              <NewReleases
                fontSize="large"
                sx={{ color: "gold", marginRight: "25px" }}
              />
              <Typography>
                {`Be on the lookout for the New Feature indicator (left)! If you see it, it means there's a new feature available nearby. When you see it, click to get more information.`}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
